import { API } from '../index'
import { ignoreNotFound } from '../errorDisposition'
import {
  crmServiceUrl,
  mappingConfigurationServiceUrl,
  marketplaceServiceUrl,
} from '../../utils/constants'
import {
  CoSellReferralMapping,
  CosellTemplateDataResponse,
  CosellTemplateDataResponseCRM,
  MarketplaceTemplateDataResponseSalesforce,
} from '../../../oppsync/modules/coSellMappingManager/reducer'
import { MarketplaceTemplateDataResponse } from '../../../flyout/modules/marketplaceMappingManager/reducer'
import { isUndefined } from 'lodash'
import { azureMarketplaceServiceUrl } from '../../utils/constants'

// GET list of templates
export const getAllReferralTemplates = (
  crmId: string,
  isActive?: boolean,
  templateType?: string,
  crmtype?: string
) =>
  API.get(`${crmServiceUrl}/crms/${crmId}/referral-templates`, {
    params: {
      is_active: isActive,
      template_type: templateType,
    },
  })

/**
 * @deprecated Deprecated by the useTemplateFromMappingService flag. Use getReferralTemplatesFromMappingService when the flag is enabled. This function can be removed once the flag is removed.
 */
export const getReferralTemplate = (
  crmId: string,
  templateId: string,
  isMapped?: boolean,
  isRequired?: boolean,
  searchedInput?: string
) =>
  API.get(`${crmServiceUrl}/crms/${crmId}/referral-templates/${templateId}`, {
    params: {
      mapped: isMapped,
      only_required_fields: isRequired,
      search: searchedInput,
    },
  })

/** Fetches a referral template from the mapping service. Use when useTemplateFromMappingService flag is enabled. */
export const getReferralTemplatesFromMappingService = (
  crmId: string,
  templateId: string,
  accountId: string,
  isMapped?: boolean,
  isRequired?: boolean,
  searchedInput?: string
) =>
  API.get(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates/${templateId}`,
    {
      params: {
        mapped: isMapped,
        required: isRequired,
        search: searchedInput,
      },
      classifyError: ignoreNotFound,
    }
  )

/** Creates a referral template in the mapping service. Use when useTemplateFromMappingService flag is enabled. */
export const postReferralTemplateFromMappingService = (
  crmId: string,
  templateData: Record<string, unknown>,
  accountId: string
) =>
  API.post(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates`,
    templateData
  )

/**
 * @deprecated Deprecated by the useTemplateFromMappingService flag. Use postReferralTemplateFromMappingService when the flag is enabled. This function can be removed once the flag is removed.
 */
export const postReferralTemplate = (
  crmId: string,
  templateData: Record<string, unknown>
) => API.post(`${crmServiceUrl}/crms/${crmId}/referral-templates`, templateData)

/** Clones a referral template in the mapping service. Use when useTemplateFromMappingService flag is enabled. */
export const postCloneReferralTemplateFromMappingService = (
  crmId: string,
  templateId: string,
  templateData: Record<string, unknown>,
  accountId: string
) =>
  API.post(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates/${templateId}/clone`,
    templateData
  )

/**
 * @deprecated Deprecated by the useTemplateFromMappingService flag. Use postCloneReferralTemplateFromMappingService when the flag is enabled. This function can be removed once the flag is removed.
 */
export const postCloneReferralTemplate = (
  crmId: string,
  templateId: string,
  templateData: Record<string, unknown>
) =>
  API.post(
    `${crmServiceUrl}/crms/${crmId}/referral-templates/${templateId}/clone`,
    templateData
  )

export const patchHubspotSectionData = (
  crmId: string,
  sectionData: Record<string, unknown>
) => {
  return API.patch(`${crmServiceUrl}/crms/${crmId}`, sectionData)
}

/** Updates a referral template in the mapping service. Use when useTemplateFromMappingService flag is enabled. */
export const putReferralTemplateFromMappingService = (
  crmId: string,
  templateId: string,
  templateData:
    | Partial<CosellTemplateDataResponse>
    | Partial<MarketplaceTemplateDataResponse>,
  accountId: string
) =>
  API.put(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates/${templateId}`,
    templateData
  )

/**
 * @deprecated Deprecated by the useTemplateFromMappingService flag. Use putReferralTemplateFromMappingService when the flag is enabled. This function can be removed once the flag is removed.
 */
export const putReferralTemplate = (
  crmId: string,
  templateId: string,
  templateData:
    | Partial<CosellTemplateDataResponse>
    | Partial<MarketplaceTemplateDataResponse>
) =>
  API.put(
    `${crmServiceUrl}/crms/${crmId}/referral-templates/${templateId}`,
    templateData
  )

// RESET a referral template
export const resetReferralTemplate = (
  crmId: string,
  templateId: string,
  templateData:
    | Partial<CosellTemplateDataResponse>
    | Partial<MarketplaceTemplateDataResponse>
) =>
  API.post(
    `${crmServiceUrl}/crms/${crmId}/referral-templates/${templateId}/reset-to-default`,
    templateData
  )

/** Deletes a referral template from the mapping service. Use when useTemplateFromMappingService flag is enabled. */
export const deleteReferralTemplateFromMappingService = (
  crmId: string,
  templateId: string,
  accountId: string
) =>
  API.delete(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates/${templateId}`
  )

/**
 * @deprecated Deprecated by the useTemplateFromMappingService flag. Use deleteReferralTemplateFromMappingService when the flag is enabled. This function can be removed once the flag is removed.
 */
export const deleteSingleReferralTemplate = (
  crmId: string,
  templateId: string
) =>
  API.delete(`${crmServiceUrl}/crms/${crmId}/referral-templates/${templateId}`)

// GET hubspot fields for a template
export const getHubspotFieldsForTemplate = (
  crmId: string,
  objectType?: string
) =>
  API.get(`${crmServiceUrl}/crms/${crmId}/referral-templates/hubspot-fields`, {
    params: {
      object_type: objectType,
    },
  })

// GET referral mapping
export const getReferralMapping = (
  crmId: string,
  isMapped?: boolean,
  searchedInput?: string
) =>
  API.get(`${crmServiceUrl}/crms/${crmId}/sync-to-hubspot-fields-config`, {
    params: {
      mapped: isMapped,
      search: searchedInput,
    },
  })

export const getReferralMappingFromMappingService = (
  crmId: string,
  accountId: string,
  isMapped?: boolean,
  searchedInput?: string
) =>
  API.get(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/referral-to-crm-field-mappings`,
    {
      params: {
        mapped: isMapped,
        search: searchedInput,
      },
    }
  )

export const putReferralMapping = (
  crmId: string,
  referralMappingData: CoSellReferralMapping
) =>
  API.put(
    `${crmServiceUrl}/crms/${crmId}/sync-to-hubspot-fields-config`,
    referralMappingData
  )

export const patchReferralMappingFromMappingService = (
  crmId: string,
  accountId: string,
  referralMappingData: CoSellReferralMapping
) =>
  API.patch(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/referral-to-crm-field-mappings`,
    referralMappingData
  )

// GET referral mapping for martketplace offers on Hubspot
export const getMarketplaceDefaultOffersReferralMapping = (
  crmId: string,
  crmObjectId: string,
  productId: string,
  templateId?: string
) => {
  return API.get(`${crmServiceUrl}/crms/${crmId}/default-offers`, {
    params: {
      crm_object_id: crmObjectId,
      template_id: templateId,
      product_id: productId,
    },
  })
}

export const getMarketplaceDefaultOfferMarketplaceMapping = (
  crmId: string,
  templateId?: string,
  accountId?: string,
  opportunityId?: string
) => {
  return API.post(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/mapping-templates/${templateId}/crm-field-values`,
    {
      parent_record_id: opportunityId,
      account_id: accountId,
    }
  )
}

// POST create or clone a mapping template for a particular Salesforce account
export const postReferralTemplateSalesforce = (
  crmId: string,
  accountId: string,
  templateData: Record<string, unknown>
) =>
  API.post(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates`,
    templateData
  )

// DELETE a referral template for CRM
export const deleteReferralTemplateCrm = (
  crmId: string,
  accountId: string,
  templateId: string
) =>
  API.delete(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates/${templateId}`
  )

export const postSalesforceSectionData = (
  crmId: string,
  accountId: string,
  syncConfiguration: any,
  cloudType?: string,
  updatedBy?: string,
  autoCreateMappings?: Record<string, string> | null,
  crmType: string = 'salesforce',
  enableReferralSyncToCrm?: boolean
) => {
  const payload: Record<string, unknown> = {
    crm_id: crmId,
    sync_configuration: syncConfiguration,
    account_id: accountId,
    cloud_type: cloudType || 'AWS',
    crm_type: crmType,
    updated_by: updatedBy || accountId,
    created_by: updatedBy || accountId,
    updated_at: new Date().toISOString(),
  }
  if (
    autoCreateMappings &&
    typeof autoCreateMappings === 'object' &&
    Object.keys(autoCreateMappings).length > 0
  ) {
    payload.auto_create_mappings = autoCreateMappings
  }
  if (enableReferralSyncToCrm !== undefined) {
    payload.enable_referral_sync_to_crm = enableReferralSyncToCrm
  }

  return API.post(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/sync_configurations`,
    payload
  )
}

export const putCrmSectionData = (
  crmId: string,
  accountId: string,
  payload: any
) => {
  return API.put(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/sync_configurations`,
    payload
  )
}

export const getSyncConfigurationsCrm = (crmId: string, accountId: string) => {
  return API.get(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/sync_configurations`
  )
}

export const getAllReferralTemplatesCrm = (
  crmId: string,
  accountId: string,
  productType?: string,
  templateType?: string,
  isDraft?: boolean,
  cloudType?: string
) =>
  API.get<CosellTemplateDataResponseCRM>(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates`,
    {
      params: {
        product_type: productType,
        template_type: templateType,
        is_draft: isDraft,
        cloud_type: cloudType,
      },
    }
  )

export const getAllMarketplaceTemplatesSalesforce = (
  crmId: string,
  accountId: string,
  templateType?: string,
  isActive?: boolean
) =>
  API.get<MarketplaceTemplateDataResponseSalesforce>(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates`,
    {
      params: {
        product_type: templateType,
        ...(!isUndefined(isActive) ? { is_draft: !isActive } : {}),
      },
    }
  )

export const getAllMarketplaceTemplatesSalesforceInAllAccounts = (
  crmId: string,
  templateType?: string,
  isActive?: boolean
) =>
  API.get<MarketplaceTemplateDataResponseSalesforce>(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/mapping-templates`,
    {
      params: {
        product_type: templateType,
        ...(!isUndefined(isActive) ? { is_draft: !isActive } : {}),
      },
    }
  )

export const getReferralTemplateForSalesforce = (
  crmId: string,
  accountId: string,
  templateId: string,
  isMapped?: boolean,
  isRequired?: boolean,
  searchedInput?: string
) =>
  API.get(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates/${templateId}`,
    {
      params: {
        mapped: isMapped,
        required: isRequired,
        search: searchedInput,
      },
    }
  )

export const putReferralTemplateForSalesforce = (
  crmId: string,
  templateId: string,
  accountId: string,
  payload: any
) => {
  return API.put(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates/${templateId}`,
    payload
  )
}
export const getCrmFieldsForTemplate = (
  crmId: string,
  accountId: string,
  tableNames?: string
) =>
  API.get(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/crm-fields${tableNames ? `?table_names=${tableNames}` : ''}`
  )

export const postCrmFieldValues = (
  crmId: string,
  accountId: string,
  templateId: string,
  crmPrimaryKeyValue?: string,
  crmUserId?: string
) => {
  const payload = {
    account_id: accountId,
    parent_record_id: crmPrimaryKeyValue,
    crm_user_id: crmUserId,
  }
  return API.post(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/mapping-templates/${templateId}/crm-field-values`,
    payload
  )
}

export const getLabraFields = (cloudProvider?: string) =>
  API.get(`${mappingConfigurationServiceUrl}/labra-fields`, {
    params: {
      cloud_provider: cloudProvider,
    },
  })

export const getProductsWithDimensions = (partnerId: string) =>
  API.get(
    `${marketplaceServiceUrl}/v1/partners/${partnerId}/all_products_dimensions`
  )

export const getAzureProductsWithDimensions = (partnerId: string) =>
  API.get(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/all_products_dimensions`
  )

export const postCloneTemplateSalesforce = (
  crmId: string,
  accountId: string,
  templateData: Record<string, unknown>
) =>
  API.post(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates`,
    templateData
  )

export const deleteTemplateSalesforce = (
  crmId: string,
  accountId: string,
  templateId: string
) =>
  API.delete(
    `${mappingConfigurationServiceUrl}/crms/${crmId}/accounts/${accountId}/mapping-templates/${templateId}`
  )
